import React, { useEffect } from 'react';
import HeroSection from '../components/home/HeroSection';
import ServicesSection from '../components/home/ServicesSection';
import WhyChooseUs from '../components/home/WhyChooseUs';
import FeaturedColleges from '../components/home/FeaturedColleges';
import StatsSection from '../components/home/StatsSection';
import TestimonialsSection from '../components/home/TestimonialsSection';
import FAQSection from '../components/home/FAQSection';
import CallToAction from '../components/common/CallToAction';

const HomePage: React.FC = () => {
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
    
    // Update document title
    document.title = 'VetEdu Consultants - BVSc Admission Guidance in India';
  }, []);

  return (
    <>
      <HeroSection />
      <ServicesSection />
      <WhyChooseUs />
      <StatsSection />
      <FeaturedColleges />
      <TestimonialsSection />
      <FAQSection />
      <CallToAction 
        title="Ready to Start Your Veterinary Journey?"
        description="Contact us today for expert guidance on BVSc admissions and take the first step toward your dream career."
        buttonText="Get in Touch"
        buttonLink="/contact"
      />
    </>
  );
};

export default HomePage;